import { BROADCAST_REMOVE_ATTENDEE_CAMERA } from 'actions/Types';

/**
 * This ensures that the attendee cam status is undefined
 * as true/false state suggest that the presenter/director is still in active session
 */
export default attendeeId => {
  return dispatch => {
    const action = {
      type: BROADCAST_REMOVE_ATTENDEE_CAMERA,
      payload: { attendeeId }
    };

    dispatch(action);
  };
};
